/* eslint-disable */
import React, { useState, useRef, useEffect } from "react";
import { db, storage } from "../../firebase-config";
import { ref as dbRef, set, get, onValue } from "firebase/database";
import {
  ref as storageRef,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./AddPatient.css";
import ChatNot from "../../components/Chat/ChatNot";
import "../../components/Chat/ChatNot.css";
import { useUserAuth } from "../../context/UserAuthContext";
// import { Button } from "react-bootstrap";
import { logPatientCreation } from "../PatientCreation";//audirlogs deepa
import CryptoJS from "crypto-js";
import { Dropdown } from "react-bootstrap";
import JSZip from "jszip";
import Select from "react-select";
// Helper function to check if a DICOM file should be excluded from ZIP creation
// Excludes dicom-seg-[1-9].dcm and dicom-sr-[1-9].dcm files
const shouldExcludeFromZip = (filename) => {
  const lowerFilename = filename.toLowerCase();
  
  // Check for dicom-seg-[1-9].dcm pattern
  const dicomSegPattern = /^dicom-seg-[1-9]\.dcm$/;
  if (dicomSegPattern.test(lowerFilename)) {
    console.log(`[ZIP Filter] Excluding DICOM-SEG file: ${filename}`);
    return true;
  }
  
  // Check for dicom-sr-[1-9].dcm pattern
  const dicomSrPattern = /^dicom-sr-[1-9]\.dcm$/;
  if (dicomSrPattern.test(lowerFilename)) {
    console.log(`[ZIP Filter] Excluding DICOM-SR file: ${filename}`);
    return true;
  }
  
  return false;
};


// State variables to hold patient details, file uploads, and progress
const AddPatient = () => {
  const [fullName, setFullName] = useState("");
  const [role] = useState("Patient");
  const [Id, setID] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [Dicom3D, setDicom3D] = useState(null);
  const [selected3DFileName, setSelected3DFileName] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [totalBytes, setTotalBytes] = useState(0);
  const [uploadedBytes, setUploadedBytes] = useState(0);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedReportFile, setSelectedReportFile] = useState(null);
  const [selectedReportFileName, setSelectedReportFileName] = useState("");
  const [selectedFolderName, setSelectedFolderName] = useState(""); // For storing the DICOM folder name
  const [selectedDicomFolderFiles, setSelectedDicomFolderFiles] = useState([]); // State for storing selected DICOM folder files
  const [modality, setModality] = useState("XRAY");
  const [selectedTest, setSelectedTest] = useState("");
  const [customTestType, setCustomTestType] = useState("");
  const adminName1 = localStorage.getItem("adminName");

  // Costing/wallet states
  const [costingType, setCostingType] = useState(""); // e.g. "Prepaid", "Postpaid", etc.
  const [walletBalance, setWalletBalance] = useState(0); // Admin's current wallet balance
  const [patientAddFee, setPatientAddFee] = useState(0); // Cost to add one patient

  const navigate = useNavigate();
  const { logOut } = useUserAuth();
  const [clinicalHistoryText, setClinicalHistoryText] = useState(""); // Store clinical history text //Viniith Added
  const [clinicalHistoryFile, setClinicalHistoryFile] = useState(null); // Store clinical history file //Viniith Added
  const file3DInputRef = useRef(null); // Ref for 3D file input
  const folderInputRef = useRef(null); // Ref for folder input
  const reportFileInputRef = useRef(null); // Ref for report file input
  const scanImageInputRef = useRef(null); // Ref for single image scan upload
  const [canSubmit, setCanSubmit] = useState(false); // Deepa Added for disable until mandatory filled
  const [ageYears, setAgeYears] = useState("");
  const [ageMonths, setAgeMonths] = useState("");
  const [hodDoctors, setHodDoctors] = useState([]);
  const [assignedHodDoctor, setAssignedHodDoctor] = useState("");

  // Decryption function for doctor data (encryptData already exists in this file)
  const decryptData = (encryptedData) => {
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      return decryptedData;
    } catch (error) {
      console.warn("AddPatient - Decryption failed, returning original data:", error);
      return encryptedData;
    }
  };

  // Function to decrypt keys and make them Firebase-safe
  const decryptKey = (encryptedKey) => {
    try {
      const base64String = encryptedKey.replace(/_/g, '/').replace(/-/g, '+');
      const encrypted = atob(base64String);
      return decryptData(encrypted);
    } catch (error) {
      console.warn("AddPatient - Key decryption failed, returning original key:", error);
      return encryptedKey;
    }
  };

  // Helper function to get doctor data (handles both encrypted and plain text)
  const getDoctorData = (doctorData, fieldName) => {
    if (!doctorData) return null;
    
    // First try direct field access (for legacy plain text data)
    if (doctorData[fieldName] !== undefined && doctorData[fieldName] !== null) {
      return decryptData(doctorData[fieldName]);
    }
    
    // Then try to find encrypted key version
    for (const key in doctorData) {
      try {
        const decryptedKey = decryptKey(key);
        if (decryptedKey === fieldName) {
          return decryptData(doctorData[key]);
        }
      } catch (error) {
        continue; // Continue to next key if decryption fails
      }
    }
    
    return null;
  };

  // Fetch HOD doctors and assign one automatically
  useEffect(() => {
    const fetchHodDoctors = async () => {
      try {
        console.log("AddPatient - Fetching HOD doctors for auto-assignment");
        const doctorsRef = dbRef(db, `superadmin/admins/${adminName1}/doctors`);
        const snapshot = await get(doctorsRef);
        
        if (snapshot.exists()) {
          const doctorsData = snapshot.val();
          const hodDoctorsList = [];
          
          Object.entries(doctorsData).forEach(([doctorId, doctorData]) => {
            // Get decrypted doctor role and name
            const decryptedRole = getDoctorData(doctorData, "Role") || doctorData.Role;
            const decryptedName = getDoctorData(doctorData, "Name") || doctorData.Name;
            
            console.log(`AddPatient - Doctor ${doctorId}:`, {
              decryptedName,
              decryptedRole
            });
            
            // Check if doctor has HOD role
            if (decryptedRole === "HOD") {
              hodDoctorsList.push({
                id: doctorId,
                name: decryptedName || "Unknown HOD",
                role: decryptedRole
              });
            }
          });
          
          console.log("AddPatient - Found HOD doctors:", hodDoctorsList);
          setHodDoctors(hodDoctorsList);
          
          // Always auto-assign HOD role (regardless of whether HOD doctors exist)
          setAssignedHodDoctor("HOD");
          if (hodDoctorsList.length > 0) {
            console.log("AddPatient - Auto-assigned HOD role (HOD doctors exist)");
          } else {
            console.log("AddPatient - Auto-assigned HOD role (no HOD doctors exist yet, but future HOD doctors will see this patient)");
          }
        } else {
          console.log("AddPatient - No doctors found in database, but still assigning HOD role");
          setHodDoctors([]);
          setAssignedHodDoctor("HOD");
        }
      } catch (error) {
        console.error("AddPatient - Error fetching HOD doctors:", error);
        console.log("AddPatient - Despite error, still assigning HOD role for future compatibility");
        setHodDoctors([]);
        setAssignedHodDoctor("HOD");
      }
    };

    if (adminName1) {
      fetchHodDoctors();
    }
  }, [adminName1]);


  // Viniith Fix this 05-08-2025 - Recompute canSubmit whenever mandatory fields change + modality validation
  useEffect(() => {
    const validName = fullName.trim() !== "" && !/\d/.test(fullName);
    const validAge = ageYears.trim() !== ""; // Fixed: check ageYears instead of age //deepadded bugs
    const validGender = gender.trim() !== "";
    const validID = Id.trim() !== "";
    
    // Viniith Fix this 05-08-2025 - Modality/Category/Test Type validation
    let validModalityFlow = true;
    if (modality.trim() !== "") {
      // If modality is selected, category must be selected
      if (selectedTest.trim() === "" || selectedTest === "Test Type") {
        validModalityFlow = false;
      }
      // If category is selected and it's "Other", custom test type must be filled
      else if (selectedTest === "Other" && customTestType.trim() === "") {
        validModalityFlow = false;
      }
    }
    
    setCanSubmit(validName && validAge && validGender && validID && validModalityFlow);
  }, [fullName, ageYears, gender, Id, modality, selectedTest, customTestType]); // Fixed: added ageYears to dependencies //deepadded bugs

  // Fetch  Wallet_Balance
  useEffect(() => {
    if (adminName1) {
      const walletBalanceRef = dbRef(
        db,
        `superadmin/admins/${adminName1}/Wallet/Wallet_Balance`
      );

      // Subscribe to realtime updates
      const unsubscribe = onValue(
        walletBalanceRef,
        (snapshot) => {
          if (snapshot.exists()) {
            setWalletBalance(snapshot.val());
          }
        },
        (error) => {
          console.error("Error listening to wallet balance updates:", error);
        }
      );

      // Cleanup subscription on unmount
      return () => unsubscribe();
    }
  }, [adminName1]);

  // Fetch admin’s CostingType, Wallet_Balance, and PatientAddFee
  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        const adminRef = dbRef(db, `superadmin/admins/${adminName1}`);
        const snapshot = await get(adminRef);

        if (snapshot.exists()) {
          const adminData = snapshot.val();
          // Example structure: adminData might contain { CostingType: "Prepaid", Wallet: { Wallet_Balance: 100 }, costing: { PatientAddFee: 10 } }
          setCostingType(adminData.CostingType || "");
          setPatientAddFee(adminData.costing?.PatientAddFee || 0);
        }
      } catch (error) {
        console.error("Failed to fetch admin data:", error);
      }
    };

    if (adminName1) {
      fetchAdminData();
    }
  }, [adminName1]);

  // Test names categorized by modality
  const testNames = {
    CT: [
      "CRANIAL PLAIN",
      "CHEST PLAIN & CONTRAST",
      "CERVICAL SPINE PLAIN",
      "CERVICAL SPINE WITH CONTRAST",
      "CHEST HR PLAIN",
    ],
    MRI: [
      "BRAIN PLAIN",
      "BRAIN WITH CONTRAST",
      "CERVICAL SPINE PLAIN",
      "CERVICAL SPINE WITH CONTRAST",
      "ABDOMEN PLAIN",
    ],
    XRAY: [
      "CHEST PA VIEW",
      "CHEST AP VIEW",
      "ABDOMEN ERECT",
      "CERVICAL SPINE AP/LAT",
      "PELVIS AP",
    ],
  };
  useEffect(() => {
    // Add the no-scroll class to prevent full-page scrolling
    document.body.classList.add("no-scroll");

    return () => {
      // Remove the class when leaving the component
      document.body.classList.remove("no-scroll");
    };
  }, []);
  // Sanitize Firebase key
  const sanitizeFirebaseKey = (key) => key.replace(/\//g, "_");

  // Encryption function
  const encryptData = (data) => {
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    if (!secretKey) {
      throw new Error("Secret key is not defined");
    }
    return CryptoJS.AES.encrypt(data, secretKey).toString();
  };

  // Notify success or error
  const notifySuccess = (message) =>
    toast.success(message, { position: "top-center" });
  const notifyError = (message) =>
    toast.error(message, { position: "top-center" });

  // Helper function to reset progress state
  const resetProgressState = () => {
    setUploadProgress(0);
    setTotalBytes(0);
    setUploadedBytes(0);
  };

  // Helper function to calculate total bytes for all uploads
  const calculateTotalUploadBytes = () => {
    let total = 0;
    
    // Add 3D file size
    if (Dicom3D) {
      total += Dicom3D.size;
    }
    
    // Add report file size
    if (selectedReportFile) {
      total += selectedReportFile.size;
    }
    
    // Add clinical history file size
    if (clinicalHistoryFile) {
      total += clinicalHistoryFile.size;
    }
    
    // Add DICOM folder files size (only original files, ZIP is handled separately)
    if (selectedDicomFolderFiles && selectedDicomFolderFiles.length > 0) {
      const dicomFolderSize = selectedDicomFolderFiles.reduce((sum, file) => sum + file.size, 0);
      total += dicomFolderSize;
      // Don't add ZIP size here - it's handled in the upload function
    }
    
    return total;
  };

  // Function to handle 3D file upload selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (
      !file.name.toLowerCase().endsWith(".gltf") &&
      !file.name.toLowerCase().endsWith(".glb")
    ) {
      notifyError("Invalid file type. Please upload a .gltf or .glb file.");
      e.target.value = "";
      return;
    }
    setDicom3D(file);
    setSelected3DFileName(file.name);
  };

  // Function to handle report file upload selection
  const handleReportFileChange = (e) => {
    const file = e.target.files[0];
    const allowedExtensions = /(\.pdf|\.docx|\.txt)$/i; // Allow only PDF, DOCX, or TXT
    if (!allowedExtensions.test(file.name.toLowerCase())) {
      notifyError(
        "Invalid file type. Please upload a .pdf, .docx, or .txt file."
      );
      e.target.value = ""; // Clear the file input
      return;
    }
    setSelectedReportFile(file);
    setSelectedReportFileName(file.name);
  };

  const removeReportFile = () => {
    setSelectedReportFile(null);
    setSelectedReportFileName("");
    if (reportFileInputRef.current) {
      reportFileInputRef.current.value = ""; // Reset the input field
    }
  };
  // Function to validate DICOM folder files
  const validateDicomFolderFiles = (e) => {
    const files = Array.from(e.target.files); // Convert FileList to an array
    if (files.length === 0) {
      notifyError("No files selected");
      return false;
    }

    // Ensure folder structure is valid and files are `.dcm`
    if (!files[0].webkitRelativePath.includes("/")) {
      notifyError("Please select a folder");
      e.target.value = "";
      return false;
    }

    const isValidDicomFolder = files.every(
      (file) =>
        file.name.toLowerCase().endsWith(".dcm") ||
        file.name.toLowerCase().endsWith(".png") ||
        file.name.toLowerCase().endsWith(".jpg") ||
        file.name.toLowerCase().endsWith(".jpeg")
    );
    if (!isValidDicomFolder) {
      notifyError("Invalid folder contents. Only DICOM (.dcm), PNG (.png), and JPEG (.jpg/.jpeg) files are allowed");
      e.target.value = "";
      return false;
    }

    setSelectedDicomFolderFiles(files); // Store valid files in state
    setSelectedFolderName(files[0].webkitRelativePath.split("/")[0]); // Extract folder name
    console.log("DICOM Files Selected:", files);
    console.log("Folder Name:", files[0].webkitRelativePath.split("/")[0]);
    return true;
  };

  // Function to handle single scan image file upload (PNG, JPG, JPEG only)
  const handleSingleScanFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files || files.length === 0) {
      return;
    }

    const isValidFile = (file) => {
      const lowerName = file.name.toLowerCase();
      return (
        lowerName.endsWith(".png") ||
        lowerName.endsWith(".jpg") ||
        lowerName.endsWith(".jpeg") ||
        lowerName.endsWith(".dcm")
      );
    };

    const allValid = files.every(isValidFile);
    if (!allValid) {
      notifyError(
        "Invalid file type. Only PNG (.png), JPEG (.jpg/.jpeg), and DICOM (.dcm) files are allowed"
      );
      e.target.value = "";
      return;
    }

    const isFolder = files[0].webkitRelativePath && files[0].webkitRelativePath.includes("/");
    setSelectedDicomFolderFiles(files);
    setSelectedFolderName(isFolder ? files[0].webkitRelativePath.split("/")[0] : files[0].name);
    console.log("Scan files selected:", files);
  };

  const handleClinicalHistoryTextChange = (e) => {
    setClinicalHistoryText(e.target.value);
  };
  
  //deepa added bugs
  const handleClinicalHistoryKeyDown = (e) => {
    if (e.key === 'Enter' && e.shiftKey) {
      // Handle Shift+Enter for line breaks manually
      e.preventDefault();
      const textarea = e.target;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const currentValue = clinicalHistoryText;
      const newValue = currentValue.substring(0, start) + '\n' + currentValue.substring(end);
      
      setClinicalHistoryText(newValue);
      
      // Set cursor position after the new line
      setTimeout(() => {
        textarea.selectionStart = textarea.selectionEnd = start + 1;
      }, 0);
    } else if (e.key === 'Enter' && !e.shiftKey) {
      // Prevent regular Enter from doing anything (like form submission)
      e.preventDefault();
    }
  };
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based, so add 1
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
  };
  const handleClinicalHistoryFileChange = (e) => {
    const file = e.target.files[0];
    setClinicalHistoryFile(file); // Set selected file
  };

  //Viniith Added
  const uploadClinicalHistoryFile = async (patientKey, currentUploadedBytes = 0) => {
    if (!clinicalHistoryFile) {
      return { filePath: "", downloadURL: "" }; // No file selected
    }
    // Define the file path in Firebase Storage
    const filePath = `superadmin/admins/${adminName1}/patients/${patientKey}/clinical_history/${clinicalHistoryFile.name}`;
    const fileRef = storageRef(storage, filePath);
    const uploadTask = uploadBytesResumable(fileRef, clinicalHistoryFile);

    return new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // 🔹 Byte-based progress tracking
          const fileUploadedBytes = snapshot.bytesTransferred;
          const totalProgressBytes = currentUploadedBytes + fileUploadedBytes;
          setUploadedBytes(totalProgressBytes);
          
          // Calculate overall progress based on total work
          const overallPercent = totalBytes > 0 ? (totalProgressBytes / totalBytes) * 100 : 0;
          setUploadProgress(Math.floor(Math.min(100, overallPercent)));
        },
        (error) => {
          console.error("Upload failed:", error);
          reject(error);
        },
        async () => {
          try {
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
            resolve({
              filePath: encryptData(filePath), // Encrypt the file path
              downloadURL: downloadURL, // Plain download URL (not encrypted)
            });
          } catch (error) {
            console.error("Failed to get download URL:", error);
            reject(error);
          }
        }
      );
    });
  };
  // Upload the 3D file to Firebase Storage
  const uploadDicom3DFile = async (filePath, currentUploadedBytes = 0) => {
    const fileRef = storageRef(storage, filePath);
    const uploadTask = uploadBytesResumable(fileRef, Dicom3D);

    return new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // 🔹 Byte-based progress tracking
          const fileUploadedBytes = snapshot.bytesTransferred;
          const totalProgressBytes = currentUploadedBytes + fileUploadedBytes;
          setUploadedBytes(totalProgressBytes);
          
          // Calculate overall progress based on total work
          const overallPercent = totalBytes > 0 ? (totalProgressBytes / totalBytes) * 100 : 0;
          setUploadProgress(Math.floor(Math.min(100, overallPercent)));
        },
        reject,
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve({ filePath, downloadURL });
        }
      );
    });
  };

  // Function to upload report file to Firebase
  const uploadReportFile = async (filePath, currentUploadedBytes = 0) => {
    if (!selectedReportFile) {
      return { filePath: "", downloadURL: "" }; // No file selected
    }
    const fileRef = storageRef(storage, filePath);
    const uploadTask = uploadBytesResumable(fileRef, selectedReportFile);

    return new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // 🔹 Byte-based progress tracking
          const fileUploadedBytes = snapshot.bytesTransferred;
          const totalProgressBytes = currentUploadedBytes + fileUploadedBytes;
          setUploadedBytes(totalProgressBytes);
          
          // Calculate overall progress based on total work
          const overallPercent = totalBytes > 0 ? (totalProgressBytes / totalBytes) * 100 : 0;
          setUploadProgress(Math.floor(Math.min(100, overallPercent)));
        },
        reject,
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve({ filePath, downloadURL });
        }
      );
    });
  };
  const removeDicom3DFile = () => {
    setDicom3D(null);
    setSelected3DFileName("");
    if (file3DInputRef.current) {
      file3DInputRef.current.value = ""; // Reset the input field
    }
  };
  
  // Helper function to check if modality is XRay
  const checkIfXRayModality = (modalityValue) => {
    if (!modalityValue) return false;
    const modalityUpper = modalityValue.toUpperCase().trim();
    return modalityUpper === "XRAY";
  };
  
  // Upload DICOM folder
const uploadDicomFolder = async (patientKey) => {
  if (!selectedDicomFolderFiles || selectedDicomFolderFiles.length === 0) {
    console.log("uploadDicomFolder: no files selected");
    return { folderPath: "", filesUploaded: 0, zipFileName: "", zipDownloadURL: "" };
  }

  const startTime = Date.now();
  const folderPath = `superadmin/admins/${adminName1}/patients/${patientKey}/folder_${Date.now()}/`;
  const encryptedFolderPath = encryptData(folderPath);
  
  // Check if this is XRay modality
  const isXRayModality = checkIfXRayModality(modality);
  console.log(`uploadDicomFolder: Modality='${modality}', Is XRay: ${isXRayModality}`);

  try {
    console.log(`uploadDicomFolder: starting. target folderPath=${folderPath}`);
    
    // 🔹 Step 1: Calculate total work (sum of all file sizes only)
    const totalFileBytes = selectedDicomFolderFiles.reduce((sum, file) => sum + file.size, 0);
    
    console.log(`uploadDicomFolder: Total DICOM files size: ${(totalFileBytes / 1024 / 1024).toFixed(2)}MB`);
    
    // Track uploaded bytes across all files
    let currentUploadedBytes = 0;
    const fileProgressMap = new Map(); // Track progress per file
    
    // For XRay: Group files by their parent folder (series)
    let fileUploadPromises;
    
    if (isXRayModality) {
      console.log(`📁 XRay Upload: Organizing files into XRay folder structure`);
      
      // Group files by series (subfolder name)
      const seriesGroups = new Map(); // Map<seriesName, files[]>
      
      selectedDicomFolderFiles.forEach(file => {
        const relative = file.webkitRelativePath || file.name;
        const pathParts = relative.split('/');
        
        // Get series name (parent folder)
        let seriesName = "XRay_Series";
        if (pathParts.length > 2) {
          seriesName = pathParts[1]; // Use second folder as series name
        } else if (pathParts.length > 1) {
          seriesName = pathParts[0]; // Use first folder as series name
        }
        
        if (!seriesGroups.has(seriesName)) {
          seriesGroups.set(seriesName, []);
        }
        seriesGroups.get(seriesName).push(file);
      });
      
      console.log(`📊 Found ${seriesGroups.size} series:`, Array.from(seriesGroups.keys()));
      
      // Upload files with XRay structure
      fileUploadPromises = [];
      let globalIndex = 0;
      
      seriesGroups.forEach((files, seriesName) => {
        console.log(`📂 Processing series '${seriesName}' with ${files.length} files`);
        
        files.forEach((file, seriesIndex) => {
          const idx = globalIndex++;
          const xrayFolderName = `${seriesName}${seriesIndex + 1}`; // e.g., Knee1, Knee2
          const fileName = file.name;
          
          // Create path: folderPath/seriesName/XRay1/file.dcm
          const filePath = `${folderPath}${seriesName}/${xrayFolderName}/${fileName}`;
          
          console.log(`📤 XRay upload: ${fileName} → ${seriesName}/${xrayFolderName}/`);
          
          const fileRef = storageRef(storage, filePath);
          const task = uploadBytesResumable(fileRef, file);
          
          fileProgressMap.set(idx, 0);
          
          const promise = new Promise((resolve, reject) => {
            task.on(
              "state_changed",
              (snap) => {
                const previousBytes = fileProgressMap.get(idx) || 0;
                const currentFileBytes = snap.bytesTransferred;
                const deltaBytes = currentFileBytes - previousBytes;
                
                fileProgressMap.set(idx, currentFileBytes);
                currentUploadedBytes += deltaBytes;
                
                const fileUploadPercent = Math.min(60, (currentUploadedBytes / totalFileBytes) * 60);
                setUploadProgress(Math.floor(fileUploadPercent));
              },
              (err) => {
                console.error(`XRay upload failed [${fileName}]`, err);
                reject(err);
              },
              async () => {
                console.log(`✅ XRay uploaded: ${fileName}`);
                resolve();
              }
            );
          });
          
          fileUploadPromises.push(promise);
        });
      });
    } else {
      // Regular upload (non-XRay): preserve relative path
      fileUploadPromises = selectedDicomFolderFiles.map((file, idx) => {
        const relative = file.webkitRelativePath || file.name;
        const filePath = `${folderPath}${relative}`;
        const fileRef = storageRef(storage, filePath);
        const task = uploadBytesResumable(fileRef, file);
        
        fileProgressMap.set(idx, 0);

        return new Promise((resolve, reject) => {
          task.on(
            "state_changed",
            (snap) => {
              const previousBytes = fileProgressMap.get(idx) || 0;
              const currentFileBytes = snap.bytesTransferred;
              const deltaBytes = currentFileBytes - previousBytes;
              
              fileProgressMap.set(idx, currentFileBytes);
              currentUploadedBytes += deltaBytes;
              
              const fileUploadPercent = Math.min(60, (currentUploadedBytes / totalFileBytes) * 60);
              setUploadProgress(Math.floor(fileUploadPercent));
            },
            (err) => {
              console.error(`uploadDicomFolder: file upload failed [${relative}]`, err);
              reject(err);
            },
            async () => {
              console.log(`uploadDicomFolder: uploaded file [${relative}]`);
              resolve();
            }
          );
        });
      });
    }

    console.log(`uploadDicomFolder: uploading ${selectedDicomFolderFiles.length} files`);
    await Promise.all(fileUploadPromises);
    console.log("uploadDicomFolder: all files uploaded to storage");

    // 2) Create ZIP using JSZip
    const zip = new JSZip();
    console.log("uploadDicomFolder: creating zip (adding files to JSZip)");
    
    // Filter out dicom-seg-[1-9].dcm and dicom-sr-[1-9].dcm files
    const filteredFiles = selectedDicomFolderFiles.filter(file => {
      const filename = file.name;
      const shouldExclude = shouldExcludeFromZip(filename);
      return !shouldExclude;
    });
    
    console.log(`uploadDicomFolder: filtered ${selectedDicomFolderFiles.length} files to ${filteredFiles.length} files (excluded DICOM-SEG/SR files)`);
    
    if (isXRayModality) {
      console.log(`📦 Creating ZIP with XRay structure for ${filteredFiles.length} files`);
      
      // Group files by series for ZIP (same logic as upload)
      const zipSeriesGroups = new Map();
      
      filteredFiles.forEach(file => {
        const relative = file.webkitRelativePath || file.name;
        const pathParts = relative.split('/');
        
        let seriesName = "XRay_Series";
        if (pathParts.length > 2) {
          seriesName = pathParts[1];
        } else if (pathParts.length > 1) {
          seriesName = pathParts[0];
        }
        
        if (!zipSeriesGroups.has(seriesName)) {
          zipSeriesGroups.set(seriesName, []);
        }
        zipSeriesGroups.get(seriesName).push(file);
      });
      
      // Add files to ZIP with XRay structure
      for (const [seriesName, files] of zipSeriesGroups.entries()) {
        for (let seriesIndex = 0; seriesIndex < files.length; seriesIndex++) {
          const file = files[seriesIndex];
          const xrayFolderName = `${seriesName}${seriesIndex + 1}`;
          const fileName = file.name;
          const zipPath = `${seriesName}/${xrayFolderName}/${fileName}`;
          
          try {
            const arrBuff = await file.arrayBuffer();
            zip.file(zipPath, arrBuff);
            console.log(`📦 Added to ZIP: ${zipPath}`);
          } catch (err) {
            console.error(`Error adding ${fileName} to ZIP:`, err);
            throw err;
          }
        }
      }
    } else {
      // Regular ZIP creation (non-XRay): use original relative paths
      for (const file of filteredFiles) {
        const relativePath = file.webkitRelativePath || file.name;
        try {
          const arrBuff = await file.arrayBuffer();
          zip.file(relativePath, arrBuff);
        } catch (err) {
          console.error(`uploadDicomFolder: failed to read file for zipping [${relativePath}]`, err);
          throw err;
        }
      }
    }

    console.log("uploadDicomFolder: generating zip blob (this can take memory/time)");
    // generateAsync with progress callback
    const zipBlob = await zip.generateAsync(
      { type: "blob", compression: "DEFLATE", compressionOptions: { level: 6 } },
      (metadata) => {
        // 🔹 Step 3: ZIP creation progress (60-90% range)
        const zipProgress = Math.floor(metadata.percent);
        
        // Calculate overall progress: 60-90% for ZIP creation
        const overallPercent = Math.min(90, 60 + (zipProgress * 30) / 100);
        setUploadProgress(Math.floor(overallPercent));
      }
    );

    console.log("uploadDicomFolder: zip generated", {
      zipSizeBytes: zipBlob.size,
      fileCount: selectedDicomFolderFiles.length,
    });

    // safety check for size (optional) — warn in console
    const MB = 1024 * 1024;
    if (zipBlob.size / MB > 500) {
      console.warn(
        `uploadDicomFolder: zip is large (${(zipBlob.size / MB).toFixed(2)} MB). Browser memory limits may be reached.`
      );
    }

    // 3) Upload the zip - save it one folder back (parent folder) from DICOM files
    const safeFolderName = selectedFolderName ? selectedFolderName.replace(/[\/\\?#\[\]]/g, "_") : `folder_${Date.now()}`;
    const zipFileName = `${safeFolderName}.zip`;
    const innerFolderName = (selectedFolderName || selectedDicomFolderFiles[0]?.webkitRelativePath?.split("/")[0] || `folder_${Date.now()}`)
    
    // Save ZIP one folder back (parent folder) from where DICOM files are stored
    // Example: If DICOM files are at: Folder1/Folder2/Folder3/Folder4/*.dcm
    // Then ZIP will be saved at: Folder1/Folder2/Folder3/file.zip (one folder back)
    // In our case:
    // DICOM files are at: ${folderPath}${innerFolderName}/*.dcm
    // ZIP will be at: ${folderPath}${zipFileName} (one folder back)
    const zipStoragePath = `${folderPath}${zipFileName}`;
    console.log(`uploadDicomFolder: ZIP will be saved one folder back at: ${zipStoragePath}`);

    const zipRef = storageRef(storage, zipStoragePath);
    const zipTask = uploadBytesResumable(zipRef, zipBlob);

    console.log(`uploadDicomFolder: uploading zip to ${zipStoragePath}`);
    // Wait for zip upload completion and track progress
    await new Promise((resolve, reject) => {
      zipTask.on(
        "state_changed",
        (snapshot) => {
          // 🔹 Step 4: ZIP upload progress (90-100% range)
          const zipUploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          
          // Calculate overall progress: 90-100% for ZIP upload
          const overallPercent = Math.min(100, 90 + (zipUploadProgress * 10) / 100);
          setUploadProgress(Math.floor(overallPercent));
        },
        (error) => {
          console.error("uploadDicomFolder: zip upload failed", error);
          reject(error);
        },
        () => {
          // Final update: set to 100%
          setUploadProgress(100);
          console.log("uploadDicomFolder: zip upload finished");
          resolve();
        }
      );
    });

    // 4) getDownloadURL for zip to confirm existence
    let zipDownloadURL = "";
    try {
      zipDownloadURL = await getDownloadURL(zipRef);
      console.log("uploadDicomFolder: zip download URL obtained", zipDownloadURL);
    } catch (err) {
      console.warn("uploadDicomFolder: failed to get zip download URL", err);
      // not fatal — still return path, but surface error
    }

    const elapsed = ((Date.now() - startTime) / 1000).toFixed(1);
    console.log(`uploadDicomFolder: completed in ${elapsed}s`);

    return {
      folderPath: encryptedFolderPath,
      filesUploaded: selectedDicomFolderFiles.length,
      zipFileName,
      zipPath: encryptData(zipStoragePath),
      zipDownloadURL: zipDownloadURL ? encryptData(zipDownloadURL) : "",
    };
  } catch (error) {
    console.error("uploadDicomFolder: unexpected error:", error);
    // propagate so caller prints error and shows notification
    throw error;
  }
};



  const removeDicomFolder = () => {
    setSelectedDicomFolderFiles([]);
    setSelectedFolderName("");
    if (folderInputRef.current) {
      folderInputRef.current.value = ""; // Reset the input field
    }
    if (scanImageInputRef.current) {
      scanImageInputRef.current.value = ""; // Reset the single image input as well
    }
  };
  // Increment upload count for the specific modality
  const incrementModalityUpload = async (modality) => {
    let modalityKey;
    switch (modality.toUpperCase()) {
      case "CT":
        modalityKey = "CTUploads";
        break;
      case "MRI":
        modalityKey = "MriUploads";
        break;
      case "XRAY":
        modalityKey = "XrayUploads";
        break;
      default:
        console.error("Invalid modality type:", modality);
        return;
    }

    const modalityRef = dbRef(
      db,
      `superadmin/admins/${adminName1}/costing/${modalityKey}`
    );
    try {
      const snapshot = await get(modalityRef);
      const currentUploads = Number(snapshot.val()) || 0;
      await set(modalityRef, currentUploads + 1); // Increment the count
      console.log(`${modalityKey} incremented successfully.`);
    } catch (error) {
      console.error(`Failed to increment ${modalityKey}:`, error);
    }
  };

  // Increment total uploads count
  const incrementTotalUploads = async () => {
    const totalUploadsRef = dbRef(
      db,
      `superadmin/admins/${adminName1}/costing/TotalUpload`
    );
    try {
      const snapshot = await get(totalUploadsRef);
      const currentUploads = Number(snapshot.val()) || 0;
      await set(totalUploadsRef, currentUploads + 1); // Increment TotalUpload
      console.log("TotalUpload incremented successfully.");
    } catch (error) {
      console.error("Failed to increment TotalUpload:", error);
    }
  };

  // Log Upload Events with Month-Year Structure
  const logUploadEvent = async (modality) => {
    const adminName1 = localStorage.getItem("adminName"); // Fetch admin name from local storage
    const currentDate = new Date();
    const monthNames = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];
    const currentMonthYear = `${
      monthNames[currentDate.getMonth()]
    } ${currentDate.getFullYear()}`;
    const eventsPath = `superadmin/admins/${adminName1}/costing/Upload_Events/${currentMonthYear}`;
    const eventsRef = dbRef(db, eventsPath);

    try {
      const snapshot = await get(eventsRef);
      const nextIndex = snapshot.exists()
        ? Object.keys(snapshot.val()).length
        : 0;

      const event = {
        PatientName: fullName,
        AdminName: adminName1 || "Unknown Admin", // Admin name
        Modality: modality,
        Timestamp: `${String(currentDate.getDate()).padStart(2, "0")}/${String(
          currentDate.getMonth() + 1
        ).padStart(2, "0")}/${currentDate.getFullYear()}, ${String(
          currentDate.getHours()
        ).padStart(2, "0")}:${String(currentDate.getMinutes()).padStart(
          2,
          "0"
        )}:${String(currentDate.getSeconds()).padStart(2, "0")}`,
      };

      await set(dbRef(db, `${eventsPath}/${nextIndex}`), event);
      console.log("Upload event logged successfully.");
    } catch (error) {
      console.error("Failed to log upload event:", error);
    }
  };

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();


    //Deepa Added  for value in full name
    if (!canSubmit) {
      return; // Stop form submission if invalid
    }

// auditlogs deepa

 // ─── DEFINE “finalCategory” + CLINICAL‐HISTORY FLAGS ────────────────────
 const finalCategory =
 selectedTest === "Other"
   ? customTestType.trim()
   : selectedTest;

const didEnterClinicalHistory = clinicalHistoryText.trim().length > 0;
const didAttachClinicalFile = clinicalHistoryFile !== null;
// ───────────────────────────────────────────────────────────────────────
    // Check mandatory fields
    if (!fullName || !Id || !ageYears || !gender) { //deepadded bugs
      notifyError("Please fill all mandatory fields: Name, ID, Age, Gender.");
      return;
    }

    //deepa bug fix
    // Validate age range
    const years = parseInt(ageYears);
    const months = parseInt(ageMonths) || 0;
    if (years < 0 || years > 150 || months < 0 || months > 11) {
      notifyError("Please enter a valid age (0-150 years, 0-11 months).");
      return;
    }
    // If admin is "Prepaid", check wallet vs patientAddFee
    if (costingType.toLowerCase() === "prepaid") {
      if (walletBalance < patientAddFee) {
        // Not enough money in wallet
        const userAgrees = window.confirm(
          "You do not have sufficient balance to add a patient.\n\nClick OK to go to Wallet page or Cancel to stay."
        );
        if (userAgrees) {
          // Pass the desired redirect route in the state (e.g. back to AddPatient)
          navigate(`/Admin/Wallet/${adminName1}`, {
            state: { redirectRoute: "/Admin/AddPatient" },
          });
        }
// auditlogs deepa
    // 2) Immediately log a failure entry with reason = "insufficient_balance"
    await logPatientCreation({
      patientIdEncrypted: encryptData(Id),
      createdBy: adminName1,
      patientName: fullName,
      uploaded3D: !!Dicom3D,
      uploadedReport: !!selectedReportFile,
      uploadedDicom: selectedDicomFolderFiles.length > 0,
      modality:                      modality,
    category:                      finalCategory,
     clinicalHistoryEntered:        didEnterClinicalHistory,
     clinicalHistoryFileAttached:   didAttachClinicalFile,
      success: false,
      failureReason: "insufficient_balance",
    });

        // Stop execution here
        return;
      }
    }

    const normalizeId = (id) => {
      const cleanedId = id.replace(/^P+/i, ""); // Remove all leading "P"s
      return `P${cleanedId}`; // Add exactly one "P" prefix
    };

    const normalizedId = normalizeId(Id); // Normalize user input ID
    console.log("ID normalization debug:", { //deepadded bugs
      originalId: Id,
      normalizedId: normalizedId
    });
    const sanitizedFullName = sanitizeFirebaseKey(fullName);
    const patientKey = `${role}-${sanitizedFullName}`;
    const encryptedFullName = encryptData(fullName);
    const formattedAge = ageMonths ? `${ageYears} Y ${ageMonths} M` : `${ageYears} years`; //deepadded bugs
    const encryptedAge = encryptData(formattedAge); //deepadded bugs
    const encryptedGender = encryptData(gender);
    const encryptedId = encryptData(Id); // Use the correct variable name

    const currentDate = new Date().toLocaleDateString("en-GB");
    const currentTimestamp = new Date().toISOString();

    // Check for scan-related files only (exclude clinical history) //deepadded bugs
    const hasScanData =
      Dicom3D !== null ||
      (selectedDicomFolderFiles && selectedDicomFolderFiles.length > 0) ||
      selectedReportFile !== null;
    
    // 🔹 Step 1: Calculate total work and initialize progress
    const totalWorkBytes = calculateTotalUploadBytes();
    setTotalBytes(totalWorkBytes);
    resetProgressState();
    setModalIsOpen(true);
    
    console.log(`handleSubmit: Total upload work calculated: ${(totalWorkBytes / 1024 / 1024).toFixed(2)}MB`);
    console.log("Upload modal check:", { //deepadded bugs
      hasScanData,
      Dicom3D: Dicom3D !== null,
      dicomFolderFiles: selectedDicomFolderFiles?.length || 0,
      reportFile: selectedReportFile !== null
    });
    
    // Only show upload modal if there are actual scan files to upload //deepadded bugs
    if (hasScanData) {
      setUploadProgress(0);
      setModalIsOpen(true);
    }
    try {
      // **Check for Duplicate ID**
      const patientsRef = dbRef(db, `superadmin/admins/${adminName1}/patients`);
      const patientsSnapshot = await get(patientsRef);
      // **Check for Duplicate ID**

      if (patientsSnapshot.exists()) {
        const patients = patientsSnapshot.val();

        const isDuplicateID = Object.values(patients).some((patient) => {
          try {
            const decryptedID = CryptoJS.AES.decrypt(
              patient.ID,
              process.env.REACT_APP_SECRET_KEY
            ).toString(CryptoJS.enc.Utf8);

            if (!decryptedID) return false; // Skip if decryption failed //deepadded bugs

            const normalizedDecryptedID = normalizeId(decryptedID);
            const isMatch = normalizedDecryptedID === normalizedId;
            
            console.log("ID comparison debug:", { //deepadded bugs
              encryptedStoredID: patient.ID,
              decryptedStoredID: decryptedID,
              normalizedStoredID: normalizedDecryptedID,
              inputNormalizedID: normalizedId,
              isMatch: isMatch
            });
            
            return isMatch;
          } catch (error) {
            console.error("Error decrypting patient ID:", error); //deepadded bugs
            return false; // Skip malformed data
          }
        });

        if (isDuplicateID) {
          console.log("DUPLICATE ID DETECTED - STOPPING EXECUTION"); //deepadded bugs
          notifyError("This ID is already in use. Please choose a unique ID.");

     // auditlogs deepa     
  // 2) Log a "patient_creation_failed" entry with reason = "duplicate_id"
  await logPatientCreation({
    patientIdEncrypted: encryptData(Id),
    createdBy: adminName1,
    patientName: fullName,
    uploaded3D: !!Dicom3D,
    uploadedReport: !!selectedReportFile,
    uploadedDicom: selectedDicomFolderFiles.length > 0,
    modality:                      modality,
    category:                      finalCategory,
     clinicalHistoryEntered:        didEnterClinicalHistory,
     clinicalHistoryFileAttached:   didAttachClinicalFile,
    success: false,
    failureReason: "duplicate_id",
  });

          console.log("EXECUTION STOPPED - RETURNING FROM FUNCTION"); //deepadded bugs
          return;
        }
        
        console.log("NO DUPLICATE FOUND - CONTINUING WITH PATIENT CREATION"); //deepadded bugs 
      }
      const uploadsRef = dbRef(
        db,
        `superadmin/admins/${adminName1}/patients/${patientKey}/uploads`
      );
      const snapshot = await get(uploadsRef);

      const uploadCount = snapshot.exists()
        ? Object.keys(snapshot.val()).length + 1
        : 1;
      const scanKey = `Scan ${uploadCount}`;

      // 🔹 Step 2: Sequential uploads with byte-based progress tracking
      let currentUploadedBytes = 0;
      
      // Upload 3D file first
      let dicom3DResult = { filePath: "", downloadURL: "" };
      if (Dicom3D) {
        const filePath = `superadmin/admins/${adminName1}/patients/${patientKey}/${Dicom3D.name}`;
        dicom3DResult = await uploadDicom3DFile(filePath, currentUploadedBytes);
        currentUploadedBytes += Dicom3D.size;
        console.log(`handleSubmit: 3D file uploaded, progress: ${currentUploadedBytes}/${totalWorkBytes} bytes`);
      }

      // Upload report file
      let reportResult = { filePath: "", downloadURL: "" };
      if (selectedReportFile) {
        const filePath = `superadmin/admins/${adminName1}/patients/${patientKey}/${selectedReportFile.name}`;
        reportResult = await uploadReportFile(filePath, currentUploadedBytes);
        currentUploadedBytes += selectedReportFile.size;
        console.log(`handleSubmit: Report file uploaded, progress: ${currentUploadedBytes}/${totalWorkBytes} bytes`);
      }

      // Upload clinical history file
      let clinicalHistoryResult = { filePath: "", downloadURL: "" };
      if (clinicalHistoryFile) {
        clinicalHistoryResult = await uploadClinicalHistoryFile(patientKey, currentUploadedBytes);
        currentUploadedBytes += clinicalHistoryFile.size;
        console.log(`handleSubmit: Clinical history uploaded, progress: ${currentUploadedBytes}/${totalWorkBytes} bytes`);
      }
      
      // Upload DICOM folder (this handles its own progress tracking internally)
      let dicomFolderResult = { folderPath: "", filesUploaded: 0 };
      if (selectedDicomFolderFiles.length > 0) {
        dicomFolderResult = await uploadDicomFolder(patientKey);
        console.log(`handleSubmit: DICOM folder uploaded`);
      }
      // Add patient details if not already added
      const patientRef = dbRef(
        db,
        `superadmin/admins/${adminName1}/patients/${patientKey}`
      );
      const patientExists = await get(patientRef);

      if (!patientExists.exists()) {
        // Initialize base patient data
        const patientData = {
          FullName: encryptedFullName,
          ID: encryptedId, // Fixed the variable name
          Role: role,
          DoctorAssigned: assignedHodDoctor ? [{
            name: assignedHodDoctor,
            assignedAt: formatDate(new Date()) // Add timestamp when HOD is assigned
          }] : [], // Store HOD assignment with timestamp
          Age: encryptedAge,
          Timestamp: currentTimestamp,
          Gender: encryptedGender,
          Version: "03",
          Addedby:
            adminName1 && adminName1.trim() !== "" ? adminName1 : "Admin", // Add admin name or fallback to "Admin"
        };

        // Add clinical history fields only if clinical history is provided
        if (clinicalHistoryText || clinicalHistoryFile) {
          patientData.Clinical_Textarea = clinicalHistoryText || ""; // Clinical history text
          patientData.Clinical_Filepath =
            clinicalHistoryResult.downloadURL || ""; // Plain clinical history file URL
          patientData.Clinical_Timestamp = formatDate(new Date()); // Timestamp
        }

        // Save patient data to Firebase
        await set(patientRef, patientData);
        // auditlogs deepa
        // …inside your handleSubmit, once all uploads/database writes succeed:
await logPatientCreation({
  patientIdEncrypted: encryptData(Id),
  createdBy: adminName1,
  patientName: fullName,
  uploaded3D: !!Dicom3D,
  uploadedReport: !!selectedReportFile,
  uploadedDicom: selectedDicomFolderFiles.length > 0,
  modality:                      modality,
  category:                      finalCategory,
   clinicalHistoryEntered:        didEnterClinicalHistory,
   clinicalHistoryFileAttached:   didAttachClinicalFile,
           success:                       true,
       failureReason:                 "",
});

      }

      // Add upload details under the scan key
      await set(
        dbRef(
          db,
          `superadmin/admins/${adminName1}/patients/${patientKey}/uploads/${scanKey}`
        ),
        {
          Dicom_3D: Dicom3D ? Dicom3D.name : "",
          Dicom_Report: selectedReportFile ? selectedReportFile.name : "", // Save report file name
          Path3D: dicom3DResult.filePath
            ? encryptData(dicom3DResult.filePath)
            : "",
          Dicom_3DURL: dicom3DResult.downloadURL
            ? encryptData(dicom3DResult.downloadURL)
            : "",
          // StudyDate: currentDate,

          //StudyDate: selectedDicomFolderFiles.length > 0 ? currentDate : null, // Always include StudyDate
          StudyDate: selectedDicomFolderFiles.length > 0 ? currentDate : "", // Always include StudyDate

          FolderPath: dicomFolderResult.folderPath, // Folder path from DICOM upload
          PathReport: reportResult.filePath
            ? encryptData(reportResult.filePath)
            : "",
          Dicom_ReportURL: reportResult.downloadURL
            ? encryptData(reportResult.downloadURL)
            : "",
          Modality: modality ? modality.toUpperCase() : "",
          // Type_of_Dicom_Data: selectedTest || "",
          Type_of_Dicom_Data:
            selectedTest === "Other" ? customTestType : selectedTest,
          // uplaodtimetamp: currentTimestamp,
          uplaodtimetamp: hasScanData ? currentTimestamp : "", // Set empty if no scan data
        }
      );

      // Increment counters and log events if a folder scan was uploaded
      if (selectedDicomFolderFiles.length > 0) {
        await incrementTotalUploads();
        if (modality) await incrementModalityUpload(modality);
        await logUploadEvent(modality);
      } else {
        console.log(
          "No folder scan uploaded. Skipping upload count increment and events log."
        );
      }

      // vinith added 18feb
      const newUploadSize = await calculateTotalStorageSize();
      if (newUploadSize) {
        const adminStorageRef = dbRef(
          db,
          `superadmin/admins/${adminName1}/AdminStorageSize`
        );
        try {
          await set(adminStorageRef, newUploadSize);
          console.log(
            `Successfully updated AdminStorageSize: ${newUploadSize}`
          );
        } catch (error) {
          console.error("Failed to update AdminStorageSize:", error);
        }
      }

      // 7) If costingType is "Prepaid", deduct the fee from wallet
      // (Within handleSubmit)
      // 7) If costingType is "Prepaid", deduct the fee from wallet
      if (costingType.toLowerCase() === "prepaid") {
        const updatedBalance = walletBalance - patientAddFee;
        const walletRef = dbRef(
          db,
          `superadmin/admins/${adminName1}/Wallet/Wallet_Balance`
        );
        await set(walletRef, updatedBalance);
        setWalletBalance(updatedBalance); // Update local state

        // For formatting a Month Year label like "FEB 2025"
        const getMonthYearLabel = () => {
          const date = new Date();
          const monthNames = [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC",
          ];
          const month = monthNames[date.getMonth()];
          const year = date.getFullYear();
          return `${month} ${year}`; // e.g. "FEB 2025"
        };

        // ----------- Log wallet transaction -----------
        try {
          // Example: "FEB 2025"
          const currentMonthYear = getMonthYearLabel();

          const walletTxPath = `superadmin/admins/${adminName1}/Wallet/Wallet_Transactions/${currentMonthYear}`;
          const walletTxRef = dbRef(db, walletTxPath);

          const txSnapshot = await get(walletTxRef);
          const nextIndex = txSnapshot.exists()
            ? Object.keys(txSnapshot.val()).length
            : 0;

          const transaction = {
            AddedBy: adminName1 || "Unknown Admin",
            PatientName: fullName,
            PatientID: Id,
            AmountDeducted: patientAddFee,
            UpdatedBalance: updatedBalance,
            Timestamp: new Date().toLocaleString("en-GB"),
          };

          await set(dbRef(db, `${walletTxPath}/${nextIndex}`), transaction);

          console.log("Transaction logged successfully:", transaction);
        } catch (err) {
          console.error("Failed to log wallet transaction:", err);
        }
        // ----------- End of new code -----------
      }

      // 8) All done //deepadded bugs
      const successMessage = hasScanData 
        ? "Patient added successfully with uploads." 
        : "Patient added successfully.";
      notifySuccess(successMessage);
      setTimeout(() => navigate("/Admin"), 2000);
    } catch (error) {
      console.error("Error:", error);
      notifyError("Failed to add patient. Please try again.");

        // Log a generic failure (e.g. “upload_or_db_error”)
        // auditlogs deepa
  await logPatientCreation({
    patientIdEncrypted: encryptData(Id),
    createdBy: adminName1,
    patientName: fullName,
    uploaded3D: !!Dicom3D,
    uploadedReport: !!selectedReportFile,
    uploadedDicom: selectedDicomFolderFiles.length > 0,
    modality:                      modality,
    category:                      finalCategory,
     clinicalHistoryEntered:        didEnterClinicalHistory,
     clinicalHistoryFileAttached:   didAttachClinicalFile,
    success: false,
    failureReason: "upload_or_db_error",
  });
    } finally {
      setModalIsOpen(false);
    }
  };

  //Viniith Added 18-02-2025
  const calculateTotalStorageSize = async () => {
    let totalSize = 0;

    // 1. Sum up the sizes of the newly uploaded files
    if (Dicom3D) {
      console.log(
        `Adding 3D File: ${Dicom3D.name}, Size: ${Dicom3D.size} bytes`
      );
      totalSize += Dicom3D.size;
    }

    if (selectedReportFile) {
      console.log(
        `Adding Report File: ${selectedReportFile.name}, Size: ${selectedReportFile.size} bytes`
      );
      totalSize += selectedReportFile.size;
    }

    if (clinicalHistoryFile) {
      console.log(
        `Adding Clinical History File: ${clinicalHistoryFile.name}, Size: ${clinicalHistoryFile.size} bytes`
      );
      totalSize += clinicalHistoryFile.size;
    }

    if (selectedDicomFolderFiles?.length > 0) {
      selectedDicomFolderFiles.forEach((file) => {
        console.log(
          `Adding DICOM Folder File: ${file.name}, Size: ${file.size} bytes`
        );
        totalSize += file.size;
      });
    }

    console.log(`New Uploaded Files Total Size: ${totalSize} bytes`);

    // 2. Get the existing storage from Firebase
    const adminStorageRef = dbRef(
      db,
      `superadmin/admins/${adminName1}/AdminStorageSize`
    );
    let currentStorageSize = 0;

    try {
      const adminStorageSnapshot = await get(adminStorageRef);
      if (adminStorageSnapshot.exists()) {
        const storedSize = adminStorageSnapshot.val();
        console.log(`Existing AdminStorageSize (Raw): ${storedSize}`);

        // Convert stored size to bytes
        currentStorageSize = parseFormattedSizeToBytes(storedSize);
        console.log(
          `Existing AdminStorageSize in Bytes: ${currentStorageSize} bytes`
        );
      } else {
        console.log(`No existing AdminStorageSize found. Initializing...`);
      }
    } catch (error) {
      console.error("Error fetching AdminStorageSize:", error);
    }

    // 3. Add the new uploaded size to the existing storage size
    const updatedStorageSizeBytes = currentStorageSize + totalSize;
    console.log(
      `Updated AdminStorageSize in Bytes: ${updatedStorageSizeBytes} bytes`
    );

    // 4. Convert to human-readable format
    const humanReadableSize = formatFileSize(updatedStorageSizeBytes);
    console.log(`Formatted Updated AdminStorageSize: ${humanReadableSize}`);

    // Return the human-readable format for wherever you need to store or display it
    return humanReadableSize;
  };

  // Utility: format bytes -> human-readable string
  const formatFileSize = (size) => {
    if (size < 1024) return `${size}B`; // bytes
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)}KB`; // KB
    if (size < 1024 * 1024 * 1024)
      return `${(size / (1024 * 1024)).toFixed(2)}MB`; // MB
    return `${(size / (1024 * 1024 * 1024)).toFixed(2)}GB`; // GB
  };

  const parseFormattedSizeToBytes = (formatted) => {
    // Remove any spaces between the number and the unit
    const normalized = formatted.replace(/\s+/g, ""); // Remove all whitespace
    const sizePattern = /^(\d+(\.\d+)?)(KB|MB|GB|B)$/i; // Match without spaces
    const match = normalized.match(sizePattern);

    if (!match) {
      return 0;
    }

    const value = parseFloat(match[1]); // e.g., 2, 4.53
    const unit = match[3].toUpperCase(); // e.g., "MB", "KB"

    switch (unit) {
      case "B":
        return value;
      case "KB":
        return value * 1024;
      case "MB":
        return value * 1024 * 1024;
      case "GB":
        return value * 1024 * 1024 * 1024;
      default:
        return 0;
    }
  };

  // Handle logout
  const handleLogout = async () => {
    try {
      await logOut();
      navigate("/");
    } catch (error) {
      console.error(error.message);
    }
  };

  
//deepa added bugs
  // Calculate age from date of birth
  const calculateAge = (dob) => {
    if (!dob) return null;
    
    const today = new Date();
    const birthDate = new Date(dob);
    
    // Check if the date is valid
    if (isNaN(birthDate.getTime())) return null;
    
    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    
    // Adjust if we haven't reached the birthday yet this year
    if (months < 0 || (months === 0 && today.getDate() < birthDate.getDate())) {
      years--;
      months += 12;
    }
    
    // Adjust if we haven't reached the birth day this month
    if (today.getDate() < birthDate.getDate()) {
      months--;
    }
    
    // Format the result
    if (years === 0 && months === 0) {
      return "0 years";
    } else if (years === 0) {
      return `${months} month${months !== 1 ? 's' : ''}`;
    } else if (months === 0) {
      return `${years} year${years !== 1 ? 's' : ''}`;
    } else {
      return `${years} year ${months} month${months !== 1 ? 's' : ''}`;
    }
  };

  // Handle manual date input
  const handleManualDateInput = (e) => {
    let value = e.target.value;
    // Allow only numbers and slashes
    value = value.replace(/[^0-9/]/g, '');
    
    // Auto-insert slashes after day and month
    if (value.length === 2 && !value.includes('/') && value !== '') {
      value = value + '/';
    } else if (value.length === 5 && value.split('/')[1]?.length === 2) {
      value = value + '/';
    }
    
    // Limit to DD/MM/YYYY format
    if (value.length <= 10) {
      setDateOfBirth(value);
    }
  };

  // Validate date on blur
  const validateManualDate = () => {
    if (!dateOfBirth) return;
    
    // Convert DD/MM/YYYY to YYYY-MM-DD for validation
    const parts = dateOfBirth.split('/');
    if (parts.length === 3) {
      const [day, month, year] = parts;
      const formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      
      // Validate the date
      if (isValidDateOfBirth(formattedDate)) {
        setDateOfBirth(formattedDate);
      }
    }
  };

  // Format date string to YYYY-MM-DD
  const formatDateString = (dateStr) => {
    if (!dateStr) return '';
    
    // If already in YYYY-MM-DD format
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      return dateStr;
    }
    
    // If in DD/MM/YYYY format
    const parts = dateStr.split('/');
    if (parts.length === 3) {
      const [day, month, year] = parts.map(part => part.padStart(2, '0'));
      return `${year}-${month}-${day}`;
    }
    
    return dateStr; // Return as is if format is unknown
  };

  // Date of Birth validation and age calculation functions
  const isValidDateOfBirth = (dob) => {
    if (!dob) return false;
    
    // Format the date string to YYYY-MM-DD for validation
    const formattedDob = formatDateString(dob);
    const selectedDate = new Date(formattedDob);
    const today = new Date();
  
    // Check if date is valid
    if (isNaN(selectedDate.getTime())) return false;
  
    // Check if date is not in the future
    if (selectedDate > today) return false;
  
    // Calculate age and validate range
    const age = calculateAge(formattedDob);
    if (age === null || age < 0 || age > 999) return false;
  
    return true;
  };
  
  // Format date for display (DD/MM/YYYY)
  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return '';
    
    // If in YYYY-MM-DD format, convert to DD/MM/YYYY
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      const [year, month, day] = dateStr.split('-');
      return `${day}/${month}/${year}`;
    }
    
    return dateStr; // Return as is if already in DD/MM/YYYY format
  };

  const handleDateOfBirthChange = (e) => {
    const selectedDate = e.target.value;
    setDateOfBirth(selectedDate);
    
    // if (isValidDateOfBirth(selectedDate)) {
    //   const age = calculateAge(selectedDate);
    //   setCalculatedAge(age);
    // } else {
    //   setCalculatedAge("");
    // }
  };

  const getDateValidationMessage = () => {
    if (!dateOfBirth) return "";
  
    const selectedDate = new Date(dateOfBirth);
    const today = new Date();
  
    if (isNaN(selectedDate.getTime())) {
      return "Please enter a valid date";
    }
    if (selectedDate > today) {
      return "Date of birth cannot be in the future";
    }
  
    // Calculate age and validate range
    const age = calculateAge(dateOfBirth);
    if (age !== null && (age < 0 || age > 999)) {
      return "Please enter a realistic age (0-999 years)";
    }
  
    return "";
  };

  const getMaxDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  const getMinDate = () => {
    const minDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 150);
    return minDate.toISOString().split('T')[0];
  };

  return (
    <>
      {/* Sidebar */}
      <div className="adminsidebar-modified"></div>
      {/* Top navigation with logout button */}
      <div className="top-nav-modified">
        <Dropdown className="ml-auto">
          <Dropdown.Toggle variant="secondary" id="dropdown-basic">
            {/* Show admin name, plus wallet balance if "Prepaid" */}
            {adminName1 || "Admin"}
            {costingType.toLowerCase() === "prepaid" &&
              ` (Balance: ₹${walletBalance})`}
          </Dropdown.Toggle>
          <Dropdown.Menu className="logout-menu">
            <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      {/* Main content */}
      <div>
        <h2 className="text-center h2addpatientadmin">Patient Enrollment</h2>
        <Link to="/Admin" className="homeButton">
          <span id="backText" className="backText">
            Back
          </span>
          <i
            id="backIcon"
            className="fas fa-long-arrow-alt-left fa-lg fa-2x"
          ></i>
        </Link>
        <form
          className="adminaddPatientForm"
          onSubmit={handleSubmit}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault(); // Prevent form submission on Enter key
            }
          }}
        >
          {/* <form className="adminaddPatientForm" onSubmit={handleSubmit}> */}
          {/* Input fields for patient details */}
          <div className="row">
            <div className="column">
              <strong className="strongaddpatient">
                Name
                <span className="required" style={{ color: "red" }}>
                  *
                </span>
              </strong>
              <input
                className="inputaddadmin"
                type="text"
                placeholder="Full Name"
                maxLength="25"
                title="Only letters and spaces allowed (Max 25 characters)"
                value={fullName}
                onChange={(e) => {
                  const value = e.target.value;
                  setFullName(value);
                  // Viniith Fix this 05-08-2025 - canSubmit handled by separate useEffect
                  setCanSubmit(!/\d/.test(value) && value.trim().length > 0); // Enable submit only if valid
                }}
                required
                style={{
                  borderColor: /\d/.test(fullName) ? "red" : "",
                }}
              />
              {/* Warning for numbers */}
              {/\d/.test(fullName) && (
                <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                  Only alphabets are allowed.
                </p>
              )}
              {/* Notify when limit is reached */}
              {fullName.length === 25 && (
                <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                  You have reached the 25-character limit.
                </p>
              )}
            </div>

            {/* Age */}
          <div className="column">
              <strong className="strongaddpatient">
                Age
                <span className="required" style={{ color: "red" }}>
                  *
                </span>
              </strong>
              <div className="age-input-container" style={{ display: "flex", gap: "10px" }}>
                <div style={{ flex: 1 }}>
                  <input
                    type="number"
                    className="inputaddadmin"
                    placeholder="Years"
                    min="0"
                    max="150"
                    value={ageYears}
                    onChange={(e) => setAgeYears(e.target.value)}
                    required
                    style={{
                      borderColor: (ageYears && (parseInt(ageYears) < 0 || parseInt(ageYears) > 150)) ? "red" : "",
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <input
                    type="number"
                    className="inputaddadmin"
                    placeholder="Months"
                    min="0"
                    max="11"
                    value={ageMonths}
                    onChange={(e) => setAgeMonths(e.target.value)}
                    style={{
                      borderColor: (ageMonths && (parseInt(ageMonths) < 0 || parseInt(ageMonths) > 11)) ? "red" : "",
                    }}
                  />
                </div>
              </div>
              {/* Validation message */}
              {((ageYears && (parseInt(ageYears) < 0 || parseInt(ageYears) > 150)) || 
                (ageMonths && (parseInt(ageMonths) < 0 || parseInt(ageMonths) > 11))) && (
                <span style={{ color: "red", fontSize: "12px", marginTop: "5px", display: "block" }}>
                  Please enter valid age (0-150 years, 0-11 months)
                </span>
              )}
            </div>
          </div>

          {/* Gender and ID selection */}
          <div className="row">
            <div className="column">
              <strong className="strongaddpatient">
                Gender
                <span className="required" style={{ color: "red" }}>
                  *
                </span>
              </strong>
              {/* deepa bug fix - replaced native select with react-select for better UI */}
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                options={[
                  { value: "Male", label: "Male" },
                  { value: "Female", label: "Female" },
                  { value: "Other", label: "Other" }
                ]}
                value={gender ? { value: gender, label: gender } : null}
                onChange={(selectedOption) => setGender(selectedOption ? selectedOption.value : "")}
                placeholder="Select Gender"
                isClearable
              />
            </div>
            <div className="column">
              <strong className="adminstrongaddpatient">
                ID
                <span className="required" style={{ color: "red" }}>
                  *
                </span>
              </strong>

              <input
                className="inputaddadmin"
                type="text"
                placeholder="ID"
                onChange={(e) => setID(e.target.value)}
                required
              />
            </div>
          </div>
          {/* Modality and test type selection */}
          <div className="row">
            <div className="column">
              <strong className="strongaddpatient">Modality</strong>
              <select
                className="inputaddadmin"
                value={modality}
                onChange={(e) => setModality(e.target.value)}
                // required
              >
                <option value="">Select</option>
                <option value="CT">CT</option>
                <option value="MRI">MRI</option>
                <option value="XRAY">X-Ray</option>
              </select>
            </div>

            <div className="column">
              <strong className="strongaddpatient">
                Category
                {/* Viniith Fix this 05-08-2025 - Show required asterisk when modality is selected */}
                {modality.trim() !== "" && (
                  <span className="required" style={{ color: "red" }}>
                    *
                  </span>
                )}
              </strong>
              <select
                className="inputaddadmin"
                value={selectedTest}
                disabled={modality.trim() === ""} // Viniith Fix this 05-08-2025 - Disable when no modality
                onChange={(e) => {
                  setSelectedTest(e.target.value);
                  if (e.target.value !== "Other") {
                    setCustomTestType(""); // Reset custom input when a predefined test is selected
                  }
                }}
                style={{
                  backgroundColor: modality.trim() === "" ? "#f5f5f5" : "",
                  cursor: modality.trim() === "" ? "not-allowed" : "pointer"
                }}
              >
                {/* <option value="" disabled> Test Type</option> */}
                <option value="">Test Type</option>

                {(testNames[modality] || []).map((test, index) => (
                  <option key={index} value={test}>
                    {test}
                  </option>
                ))}
                {modality.trim() !== "" && <option value="Other">Other</option>}
              </select>
              
              {/* Viniith Fix this 05-08-2025 - Helper message when modality not selected */}
              {modality.trim() === "" && (
                <p style={{ color: "#666", fontSize: "12px", marginTop: "5px", fontStyle: "italic" }}>
                  Please select a Modality first to choose Category
                </p>
              )}

              {/* Show custom input field if "Other" is selected */}
              {selectedTest === "Other" && (
                <input
                  type="text"
                  placeholder="Enter Custom Test Type"
                  className="inputaddadmin"
                  value={customTestType}
                  onChange={(e) => setCustomTestType(e.target.value)}
                  style={{
                    marginTop: "10px"
                  }}
                  required
                />
              )}
            </div>
          </div>

          <div className="column">
            <strong className="strongaddpatient">Clinical History</strong>

            {/* Wrapper to position textarea and file icon together */}
            <div className="textarea-wrapper">
              {/* Clinical History Textarea */}
              <textarea
                className="inputaddpatient"
                placeholder="Enter Clinical History"
                value={clinicalHistoryText}
                onChange={handleClinicalHistoryTextChange}
                onKeyDown={handleClinicalHistoryKeyDown}
              />

              {/* Hidden File Input */}
              <input
                type="file"
                id="clinicalHistoryFileInput"
                className="hidden-input"
                onChange={handleClinicalHistoryFileChange}
              />

              {/* Show File Name & ❌ Instead of 📎 When a File is Attached */}
              {clinicalHistoryFile ? (
                <div className="file-display">
                  <span className="file-name">{clinicalHistoryFile.name}</span>
                  <button
                    className="remove-file-btn"
                    onClick={() => {
                      setClinicalHistoryFile(null);
                      document.getElementById(
                        "clinicalHistoryFileInput"
                      ).value = ""; // Reset input field
                    }}
                  >
                    ❌
                  </button>
                </div>
              ) : (
                // Show Attach File Icon if No File is Selected
                <label
                  htmlFor="clinicalHistoryFileInput"
                  className="attach-file-icon"
                  title="Attach File"
                >
                  <i className="fas fa-paperclip"></i>
                </label>
              )}
            </div>
          </div>

          {/* File upload inputs */}

          <div className="file-upload-row">
            {/* 3D File Upload - COMMENTED OUT */}
            {/* <div className="file-upload-column">
              <label className="file-upload-label">3D</label>
              <div
                className="file-upload-input"
                onClick={() => file3DInputRef.current.click()}
              >
                <button
                  type="button"
                  className="choose-file-btn"
                  title="Choose file"
                >
                  <i className="fas fa-file-upload"></i>
                </button>

                <span className="file-name-display">
                  {selected3DFileName ? (selected3DFileName.length > 5 ? `${selected3DFileName.slice(0,5)}...` : selected3DFileName) : "No file selected"}
                </span>

                <input
                  type="file"
                  ref={file3DInputRef}
                  className="hidden-file-input"
                  accept=".gltf,.glb"
                  onChange={handleFileChange}
                />

                {selected3DFileName && (
                  <button
                    type="button"
                    className="remove-file-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setDicom3D(null);
                      setSelected3DFileName("");
                      file3DInputRef.current.value = "";
                    }}
                  >
                    ❌
                  </button>
                )}
              </div>
            </div> */}

            {/* Scan (Image File) Upload */}
            <div className="file-upload-column">
              <label className="file-upload-label">Scan</label>
              <div
                className="file-upload-input"
                onClick={() => folderInputRef.current && folderInputRef.current.click()}
              >
                <button
                  type="button"
                  className="choose-file-btn"
                  title="Choose file"
                >
                  <i className="fas fa-file-upload"></i>
                </button>

                <span className="file-name-display">
                  {selectedFolderName
                    ? selectedFolderName.length > 15
                      ? `${selectedFolderName.slice(0, 15)}...`
                      : selectedFolderName
                    : "No file selected"}
                </span>

                {/* Scan folder/file input */}
                <input
                  type="file"
                  ref={folderInputRef}
                  className="hidden-file-input"
                  accept=".png,.jpg,.jpeg,.dcm"
                  webkitdirectory=""
                  onChange={handleSingleScanFileChange}
                />

                {selectedFolderName && (
                  <button
                    type="button"
                    className="remove-file-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      removeDicomFolder();
                    }}
                  >
                    ❌
                  </button>
                )}
              </div>
            </div>

            {/* Report File Upload */}
            <div className="file-upload-column">
              <label className="file-upload-label">Report</label>
              <div
                className="file-upload-input"
                onClick={() =>
                  reportFileInputRef.current && reportFileInputRef.current.click()
                }
              >
                <button
                  type="button"
                  className="choose-file-btn"
                  title="Choose file"
                >
                  <i className="fas fa-file-upload"></i>
                </button>

                <span className="file-name-display">
                  {selectedReportFileName
                    ? selectedReportFileName.length > 5
                      ? `${selectedReportFileName.slice(0, 5)}...`
                      : selectedReportFileName
                    : "No file selected"}
                </span>

                <input
                  type="file"
                  ref={reportFileInputRef}
                  className="hidden-file-input"
                  accept=".pdf,.docx,.txt"
                  onChange={handleReportFileChange}
                />

                {selectedReportFileName && (
                  <button
                    type="button"
                    className="remove-file-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      removeReportFile();
                    }}
                  >
                    ❌
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Submit button */}
          <button
            className="addpatientbtn"
            disabled={!canSubmit}
            style={{
              backgroundColor: !canSubmit ? "#b0b0b0" : "", // Grey when disabled
              cursor: !canSubmit ? "not-allowed" : "pointer",
            }}
            title={!canSubmit ? "Please Fill Out Form" : ""}
          >
            ADD
          </button>
          {/* <button className="addpatientbtn">ADD</button> */}
          <ToastContainer />
        </form>
      </div>
      {/* Chat notification component */}
      <div>
        <ChatNot />
      </div>
      {/* Upload progress modal */}
      {modalIsOpen && (
        <div className="modal-overlay">
          <div className="modalUpload">
            <h2>Uploading...</h2>
            <div className="modal-upload-progress">
              <div
                className="bar"
                style={{ width: `${uploadProgress}%` }}
              ></div>
            </div>
            <div className="progress-info">
              <span className="progress-percent">{uploadProgress}%</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddPatient;
